import { usePostTwoFactorAuth } from "Login/TwoFA/API/queries";
import { useTwoFAContext } from "Login/TwoFA/TwoFA";

import FnrSlides from "UI/FnrSlides";

import { useActiveComponentKey } from "../../stateHooks";
import HelpMessage from "../HelpMessage";

import { useComponentsConfig } from "./componentsConfig";

const ComponentSwitch = () => {
  const activeComponentKey = useActiveComponentKey();
  const componentsConfig = useComponentsConfig();
  const { variant } = useTwoFAContext();
  const { isInitialLoading } = usePostTwoFactorAuth({ variant });
  if (isInitialLoading) return null;
  return (
    <div>
      <FnrSlides
        components={componentsConfig}
        activeKey={activeComponentKey}
        fullWidth
        clip={false}
      />
      <HelpMessage />
    </div>
  );
};

export default ComponentSwitch;
